import { medstarEntities } from "../../sitel/commons/services/lookups";

export const normalizationMappings = {
    phone: {
        normalize: value => value.replace(/[^0-9]/g, '')
    },
    state: {
        normalize: value => value.trim().toUpperCase()
    },
    vendor: {
        reverseNormalize: value => value.toString()
    },
    ssn4: {
        normalize: value => value.trim(),
        reverseNormalize: value => value.toString().padStart(4, '0')
    },
    medstarEntity: {
		normalize: value => {
	        const foundEntity = medstarEntities.find(entity => entity[1] === value);
	        return foundEntity ? foundEntity[0] : ''; // Return an empty string if no matching entity is found
	    },
	    reverseNormalize: value => {
	        const foundEntity = medstarEntities.find(entity => entity[0] === value);
	        return foundEntity ? foundEntity[1] : ''; // Return an empty string if no matching entity is found
	    }
    },

    
    // If i didn't have this on for testing with the mock data - i would get 500 error as i get this message in logs
    // [leader_email] => Array
    // (
    //     [0] => crusaders@cosmo.bush is not a Medstar email
    // )

    // leaderEmail: {
    //     normalize: () => "leader-email@medstar.net"
    // }

    // Add more mappings as needed
};

export function normalizeUserDemographics(demographics) {

    for (const section of ["editable_fields", "readonly_fields"]) {
        if (demographics[section]) {
            for (const field in demographics[section]) {
                if (normalizationMappings[field]?.normalize) {
                    demographics[section][field] = normalizationMappings[field].normalize(demographics[section][field]);
                }
            }
        }
    }
}

//Used when submitting the data back.
export function reverseNormalizeUserData(userData) {

    const reversedData = {};

    for (const field in userData) {
        reversedData[field] = normalizationMappings[field]?.reverseNormalize ? normalizationMappings[field].reverseNormalize(userData[field]) : userData[field];
    }

    return reversedData;
}
